import { Faq } from "@/features/landing/components/Faq.tsx";
import { FinalCta } from "@/features/landing/components/FinalCta.tsx";
import { Hero } from "@/features/landing/components/Hero.tsx";
import { HowItWorks } from "@/features/landing/components/HowItWorks.tsx";
import { Personas } from "@/features/landing/components/Personas.tsx";
import { SiteFooter } from "@/features/landing/components/SiteFooter.tsx";
import { SiteHeader } from "@/features/landing/components/SiteHeader.tsx";
import { Workday } from "@/features/landing/components/Workday.tsx";

export function HomePage() {
	return (
		<>
			<SiteHeader />
			<main data-slot="home-page" id="topo">
				<Hero />
				<HowItWorks />
				<Workday />
				<Personas />
				<Faq />
				<FinalCta />
			</main>
			<SiteFooter />
		</>
	);
}
